var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGumbBrand1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1357_1302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 1.14195e-05C13.4464 1.14195e-05 0 13.447 0 30C0 46.5536 13.4464 60.0001 30 60.0001C46.5536 60.0001 60 46.5536 60 30C60.0093 24.1925 58.3247 18.5084 55.1528 13.6436C55.8134 12.621 56.1666 11.4302 56.1702 10.2128C56.1702 6.70278 53.2979 3.8298 49.7872 3.8298C48.5272 3.8298 47.3489 4.21022 46.3564 4.84724C41.4899 1.6791 35.8069 -0.00505993 30 1.14195e-05ZM30 2.5532C35.3247 2.5532 40.2772 4.06277 44.4817 6.68235C43.7785 7.72536 43.4033 8.95485 43.4043 10.2128C43.4043 13.7234 46.2766 16.5958 49.7872 16.5958C51.0428 16.6008 52.2715 16.2329 53.3177 15.5387C56.0212 19.8773 57.4519 24.888 57.4468 30C57.4468 45.1736 45.1736 57.4469 30 57.4469C14.8264 57.4469 2.55319 45.1736 2.55319 30C2.55319 14.8264 14.8264 2.5532 30 2.5532V2.5532ZM30 12.1277C20.1447 12.1277 12.1277 20.1447 12.1277 30C12.1277 33.1111 12.9383 36.0294 14.3419 38.5775C13.7547 39.4085 13.4043 40.403 13.4043 41.4894C13.4043 44.2947 15.7053 46.5958 18.5106 46.5958C19.5526 46.5961 20.5694 46.2758 21.4232 45.6786C24.0516 47.1209 27.0019 47.8755 30 47.8724C39.8553 47.8724 47.8723 39.8553 47.8723 30C47.8723 20.1447 39.8553 12.1277 30 12.1277V12.1277ZM30 14.6809C38.4753 14.6809 45.3192 21.5247 45.3192 30C45.3192 38.476 38.4753 45.3192 30 45.3192C27.51 45.3192 25.1885 44.7153 23.1185 43.6634C23.4439 42.9847 23.6141 42.2421 23.617 41.4894C23.617 38.6847 21.316 36.383 18.5106 36.383C17.7249 36.383 16.9838 36.5802 16.3162 36.9019C15.2662 34.8287 14.6809 32.4945 14.6809 30C14.6809 21.5247 21.5247 14.6809 30 14.6809V14.6809ZM30 22.9787C26.1377 22.9787 22.9787 26.1377 22.9787 30C22.9787 33.863 26.1377 37.0213 30 37.0213C33.8623 37.0213 37.0213 33.863 37.0213 30C37.0213 26.1377 33.8623 22.9787 30 22.9787ZM30 25.5319C32.483 25.5319 34.4681 27.517 34.4681 30C34.4681 32.483 32.483 34.4681 30 34.4681C27.517 34.4681 25.5319 32.483 25.5319 30C25.5319 27.517 27.517 25.5319 30 25.5319Z",
    fill: "url(#paint0_linear_1357_1302)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1357_1302",
    x1: 0,
    y1: 0.0000107288,
    x2: 60,
    y2: 0.0000107288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1EFFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1357_1302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGumbBrand1);
export default __webpack_public_path__ + "static/media/gumb-brand-1.914872e3.svg";
export { ForwardRef as ReactComponent };